__turbopack_context__.v({
  "className": "figtree_73bfc3a3-module__e25u_q__className",
  "variable": "figtree_73bfc3a3-module__e25u_q__variable",
});
